import { render, staticRenderFns } from "./PowerFunctionViz.vue?vue&type=template&id=3aade186&scoped=true"
import script from "./PowerFunctionViz.vue?vue&type=script&lang=js"
export * from "./PowerFunctionViz.vue?vue&type=script&lang=js"
import style0 from "./PowerFunctionViz.vue?vue&type=style&index=0&id=3aade186&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aade186",
  null
  
)

export default component.exports